export var AssetType;
(function (AssetType) {
    AssetType["Company"] = "company";
})(AssetType || (AssetType = {}));
export var AssetHistoryType;
(function (AssetHistoryType) {
    AssetHistoryType["Investment"] = "INVESTMENT";
    AssetHistoryType["Realisation"] = "REALISATION";
    AssetHistoryType["Revaluation"] = "REVALUATION";
})(AssetHistoryType || (AssetHistoryType = {}));
//# sourceMappingURL=index.js.map